<template>
  <div class="BasebandEvents">
    <h2>CHIME FRB Baseband Event Triggers</h2>
    <b-container fluid>
      <b-row>
        <b-col md="4" class="my-1">
          <b-form-group horizontal label="Filter" class="mb-0">
            <b-input-group>
              <b-form-input v-model="filter" placeholder="Type to Search" />
              <b-input-group-append>
                <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="4" class="my-1">
          <b-form-group horizontal label="Per page" class="mb-0">
            <b-form-select :options="pageOptions" v-model="perPage" />
          </b-form-group>
        </b-col>
        <b-col md="4" class="my-1">
          <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />
        </b-col>
      </b-row>
      <b-row>
        <b-table show-empty
               :items="items"
               :fields="fields"
               :small="smallTable"
               :current-page="currentPage"
               :per-page="perPage"
               :filter="filter"
               :sort-by.sync="sortBy"
               :sort-desc.sync="sortDesc"
               :sort-direction="sortDirection"
               @filtered="onFiltered"
      >
      </b-table>
      </b-row>
      <b-row>
      <b-col md="4">
      </b-col>
      <b-col md="4">
      </b-col>
      <b-col md="4">
      </b-col>
    </b-row>
    </b-container>
  </div>
</template>
<style type="text/css">
.logTable{
  border: 1px solid black;
}
</style>
<script>
import servicesCard from './servicesCard'
import { AuthVerificationMixin } from '../mixins/auth_mixin.js'
var baseUrl = 'https://frb.chimenet.ca/frb-master/'
var fields = [
  {key: 'event_no_id', label: 'Event No', sortable: true, 'class': 'text-center'},
  {key: 'dm', label: 'DM', sortable: true, 'class': 'text-center'},
  {key: 'combined_snr', label: 'SNR', sortable: true, 'class': 'text-center'},
  {key: 'timestamp_utc', label: 'Time', sortable: true, 'class': 'text-center'},
  {key: 'source_category_name', label: 'Type', sortable: true, 'class': 'text-center'},
  {key: 'source_category_type', label: 'Name', sortable: true, 'class': 'text-center'},
  {key: 'data_path', label: 'CHIME DATA PATH', sortable: true, 'class': 'text-center'},
  {key: 'num_freqs', label: '#channels', sortable: true, 'class': 'text-center'}
]
export default {
  mixins: [AuthVerificationMixin],
  data () {
    return {
      baseUrl: baseUrl,
      eventNum: null,
      items: [],
      fields: fields,
      plots: {},
      smallTable: true,
      dark: false,
      fixed: true,
      currentPage: 1,
      perPage: 5,
      // totalRows: items.length,
      pageOptions: [ 5, 10, 15, 50, 100 ],
      sortBy: 'id',
      plot: null,
      sortDesc: true,
      sortDirection: 'asc',
      filter: null
    }
  },
  mounted () {
    // this.refreshToken()
    this.fetchEvents()
  },
  computed: {
    totalRows () {
      return this.items.length
    }
  },
  methods: {
    fetchEvents () {
      var url = 'https://frb.chimenet.ca/chimefrb/astro_events/baseband_events'
      this.refreshToken()
      // var authHeaders = {'Authorization': localStorage.accessToken}
      this.$http.get(url, {responseType: 'json'})
        .then(response => {
          this.parseEvents(response.body)
        })
    },
    parseEvents (events) {
      this.items = []
      for (var i = 0; i < events.length; i++) {
        var item = events[i]
        item['_rowVariant'] = 'danger'
        this.items.push(item)
      }
    },
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    }
  },
  components: {
    'services': servicesCard
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Outriggers/baseband_events.vue